<template>
  <div>
    <div class="my-8">
      <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        class="w-full"
        @keyup.native.enter="simpleLogin"
      />
      <span class="text-danger text-sm">{{ errors.first("email") }}</span>
    </div>

    <div class="my-8">
      <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:8'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full"
        @keyup.native.enter="simpleLogin"
      />
      <span class="text-danger text-sm">{{ errors.first("password") }}</span>
    </div>

    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
        >Remember Me</vs-checkbox
      >
      <router-link to="/pages/forgot-password">Forgot Password?</router-link>
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <!-- <vs-button type="border">Register</vs-button> -->
      <vs-button :disabled="!validateForm" @click="simpleLogin">Login</vs-button>
    </div>
    <!-- {{isUserLoggedIn}} -->

    <vs-divider />

    <div class="flex flex-1 justify-center">
      <!-- <button @click="loginWithGoogle" class="google_signup_btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg>
        <span>Sign in with Google</span>
      </button> -->

      <a :href="`${baseURL}google/redirect?subdomain=${subdomain}`" class="google_signup_btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg>
        <span>Sign in with Google</span>
      </a>
    </div>

  </div>
</template>

<script>
// import { Login } from '../../../api/login'
// import { getSubdomainExists } from '@/api/login'
import router from '@/router'
import { mapActions, mapGetters } from 'vuex'
// import {EventBus} from '../messaging/mixin/EventBus'

export default {
  data () {

    return {
      // email: 'yasin.quraishy@gmail.com',
      email: '',
      password: '',
      checkbox_remember_me: false,
      loginMode: null,
      baseURL: process.env.VUE_APP_API_URL,
      subdomain: 'scoolio'
    }
  },
  computed: {
    ...mapGetters(['isUserLoggedIn']),
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  created () {
    if (this.isUserLoggedIn) {
      this.$router.push('/pages/switch').catch(() => {})
    }

    const hostname = window.location.hostname

    if (hostname !== 'localhost') {
      this.subdomain = hostname.split('.')[0]
    }
  },
  mounted () {
    const urlData = window.location.href.split('/')
    if (typeof urlData[3] !== 'undefined') {
      if (urlData[3] !== 'pages') {

        // getSubdomainExists(urlData[3]).then(response => {
        //   if (typeof response.data.data.data.status !== 'undefined') {
        //     EventBus.$emit('updateParent', response.data.data.data.school_name)
        //     if (response.data.data.data.status === false) {
        //       this.$swal(response.data.data.data.message, {
        //         closeOnClickOutside: false,
        //         buttons: false
        //       })
        //     } else {
        const cookie = this.checkIsRemembered()
        if (cookie) {
          const cookieData = cookie.split(':')
          this.checkbox_remember_me = true
          this.email = cookieData[0]
          this.password = cookieData[1]
        }
        //     }

        //   }
        // }).catch(apiError => {
        //   this.$vs.notify({
        //     title: 'Warning',
        //     text: apiError,
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'warning',
        //     time: 8000
        //   })
        // })
      }

    }
  },
  methods: {
    ...mapActions(['SET_USER_INFO']),
    async loginJWT (payload) {
      if (this.$store.getters.isUserLoggedIn) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          ...this.warnProp()
        })
        router.push(router.currentRoute.query.to || '/')
      } else {
        this.$vs.loading()
        this.$store
          .dispatch('loginJWT', payload)
          .then((response) => {

            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Logged in',
              text: response.data.message,
              ...this.successProp()
            })
            this.SET_USER_INFO(response.data.data.user)

            if (
              this.$store.getters.customerId === '' ||
              this.$store.getters.customerId === null
            ) {
              this.$router.push('/pages/switch').catch(() => {})
            } else {
              router.push(router.currentRoute.query.to || '/').catch(() => {})
            }
          })
          .catch((error) => {

            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.data.message,
              ...this.errorProp()
            })
          })
      }
    },
    simpleLogin () {
      //Set a cookie to remember user id and password if checkbox is true
      const encodedValue = encodeURIComponent(`${this.email}:${this.password}`)

      if (this.checkbox_remember_me) {
        document.cookie = `scoolio=${encodedValue}; path='/'; Secure; max-age=157680000`
      } else {
        document.cookie = `scoolio=${encodedValue}; path='/'; Secure; max-age=0`
      }

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
          mode: 'normal_login'
        }
      }

      this.loginJWT(payload)
    },
    /* async loginWithGoogle () {
      try {
        const googleUser = await this.$gAuth.signIn()
        if (!googleUser) {
          return null
        }

        const authResponse = googleUser.getAuthResponse()

        const payload = {
          userDetails: {
            mode: 'google_login',
            google_token: authResponse.access_token
          }
        }

        this.loginJWT(payload)

      } catch (error) {
        return null
      }
    }, */
    checkIsRemembered: () => {
      const allCookies = document.cookie.split(';')

      for (let i = 0; i < allCookies.length; i++) {
        const cookiePair = allCookies[i].split('=')

        if ('scoolio' === cookiePair[0].trim()) {
          // Decode the cookie value and return
          return decodeURIComponent(cookiePair[1])
        }
      }

      return null
    }
  }
}
</script>
